var module = angular.module('octopusApp.infrastructure');

module.directive('lastModified', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '=model'
    },
    template: "<div ng-show='model.LastModifiedBy' class='control-group'><div class='controls'><div class='last-modified'>Last modified by {{ model.LastModifiedBy }} {{ model.LastModifiedOn | moment:'ago' }}</div></div></div>"
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/last_modified.js
// module id = 8841164118234567
// module chunks = 1